import { useMutation, useQueryClient } from '@tanstack/react-query';

import { type SizeSettingPresetResponse, SizeSettings } from '@air/api';
import { callAirApi } from '@air/utils-api';
import { reportErrorToBugsnag } from '@air/utils-error';

import { getPrivateSizePresetsListKey } from '../usePrivateSizePresetsList';

export type UsePrivateSizePresetsUpdateMutationParams = NonNullable<Parameters<typeof SizeSettings.Presets.update>[0]>;

export const usePrivateSizePresetsUpdateMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: UsePrivateSizePresetsUpdateMutationParams) => {
      return callAirApi<SizeSettingPresetResponse>(() => SizeSettings.Presets.update(params));
    },

    onError: (error, variables) => {
      reportErrorToBugsnag({
        context: 'Failed to update size preset',
        error,
        metadata: {
          data: variables,
          key: 'data',
        },
      });
    },

    onSettled: async (_data, _error, variables) => {
      await queryClient.invalidateQueries({
        queryKey: getPrivateSizePresetsListKey({ workspaceId: variables.workspaceId }),
      });
    },
  });
};
